export default __webpack_public_path__ + "static/media/531.b32d19c0.png";